import styled from 'styled-components';

import DateFilterCalendar from './component';

export default styled(DateFilterCalendar)`
  && {
    font-size: ${(props) => props.theme.base.textSizes.M};
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    background-color: var(--primary500);
    color: #fff;

    &:hover {
      background-color: var(--primary700);
    }
  }

  &.DayPicker:not(.DayPicker--interactionDisabled) {
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside) {
      &:hover {
        background-color: var(--primary100);
      }
    }
  }

  .DayPicker-Day {
    height: 3.2rem;
    width: 3.2rem;
  }

  .DayPicker-Day--today {
    color: inherit;
  }

  .DayPicker-wrapper {
    padding-bottom: 0;
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
    background-color: var(--primary100) !important;
    color: var(--primary900);
  }

  .DayPicker-Day {
    border-radius: 0 !important;
  }

  .DayPicker-Day--start {
    border-top-left-radius: 50% !important;
    border-bottom-left-radius: 50% !important;
  }

  .DayPicker-Day--end {
    border-top-right-radius: 50% !important;
    border-bottom-right-radius: 50% !important;
  }
`;
